import { makeStyles } from "@material-ui/styles"

const styles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(0, 4),
    minHeight: 65,
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(0, 4)
    }
  }
}))

export default styles



// WEBPACK FOOTER //
// ./src/pages/Admin/pages/Communication/ToggleBar/styles.js